module.exports = __webpack_public_path__ + "img/MX-B048046C-BD-HQ.7b71afe9.png";